import React from 'react';
import {CustomZDDropdown} from '../../../atoms/custom-zd-dropdown/CustomZDDropdown';
import {AnalystDashboardProperties} from '../../../pages/analyst/AnalystDashboardProperties';

import styles from "./styles.module.scss";
import {RenderIfAuthorized} from "../../../authorization/RenderIfAuthorized";
import {Authorizations} from "../../../authorization/Authorizations";
import { useHistory } from "react-router-dom";
import {ReactComponent as Book} from "@zendeskgarden/svg-icons/src/16/book-open-stroke.svg";
import {Business, Group} from '@material-ui/icons';
import {Tab, TabList, Tabs} from '@zendeskgarden/react-tabs';

export enum AnalystSections {
    Renovations,
    RenovationCategories,
    Payroll,
}

const AnalystSectionTabs = (props: {
    showingSection:AnalystSections,
    propertiesFilter: AnalystDashboardProperties,
    hasUnitLevelModeling: boolean
}):JSX.Element => {
    const history = useHistory();

    return (
        <React.Fragment>
            <div className={styles.sectionNav}>
                <Tabs selectedItem={props.showingSection}>
                    <TabList>
                        <RenderIfAuthorized required={Authorizations.PlanningHubPayroll}>
                            <Tab
                                item={AnalystSections.Payroll}
                                onClick={() => {
                                    history.push('/hub/payroll');
                                }}
                            >
                                <Group className={styles.tabIcon} /> Payroll
                            </Tab>
                        </RenderIfAuthorized>
                        {!props.hasUnitLevelModeling &&
                            <>
                                <Tab
                                    item={AnalystSections.Renovations}
                                    onClick={() => {
                                        history.push('/hub/renovations');
                                    }}
                                >
                                    <Business className={styles.tabIcon} /> Renovations
                                </Tab>
                                <Tab
                                    item={AnalystSections.RenovationCategories}
                                    onClick={() => {
                                        history.push('/hub/renovations-categories');
                                    }}
                                >
                                    <Book className={styles.tabIcon} /> Renovation Categories
                                </Tab>
                            </>
                        }
                    </TabList>
                </Tabs>
                {props.showingSection == AnalystSections.Payroll
                        && <div className={styles.propertiesSelector}>
                        <CustomZDDropdown
                            initialSelectedItems={props.propertiesFilter.initialSelectedProperties}
                            applySelectedItems={function (items: any): void {
                                props.propertiesFilter.applyPropertiesSelection(items);
                            } }
                            openDropdownPlaceholder={"Properties"}
                            closedDropdownPlaceholder={"Properties"}
                            options={props.propertiesFilter.isReady ? props.propertiesFilter.propertyOptions : []}
                            isError={undefined}
                            isMulti
                            allOption
                        />
                </div>}
            </div>
        </React.Fragment>
    );
};

export default AnalystSectionTabs;
